export class InsertPersRequestDTO{
    constructor(){
        this.PersRowsToInsert = []
    }
}

export class InsertPersRowDTO{
    constructor(){
        this.IdConfigurazione,
        this.CodicePersonalizzazione,
        this.NomeLogo,
        this.CodNumColoriDaStampare,
        this.CodPosizioneStampa,
        this.RelativePathFileLogo,
        this.PostInvioLogo,
        this.Note,

        this.CodCatNumColoriDaStampare,
        this.DescPersonalizzazione,
        this.DescNumColoriDaStampare,
        this.DescPosizioneStampa,
        this.MaxMisuraBase,
        this.MaxMisuraAltezza,
        this.CodiceIva
    }
}